module.exports = __webpack_public_path__ + "static/media/Avenir-Roman-12.c6d37b26.ttf";